import { render, staticRenderFns } from "./WysiwygRedactor.vue?vue&type=template&id=4b813ad4"
import script from "./WysiwygRedactor.vue?vue&type=script&lang=js"
export * from "./WysiwygRedactor.vue?vue&type=script&lang=js"
import style0 from "./WysiwygRedactor.vue?vue&type=style&index=0&id=4b813ad4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports